module.exports = __webpack_public_path__ + "img/lynx.d9aa614a.jpg";